export enum TwitterConnectLocalStorage {
    UserNYTwitterConnected = 'NYTwitterConnected',
    UserSkippedTwitter = 'UserSkippedTwitter',
    UserChangeTwitter = 'UserChangeTwitter',
}
